import React, {
  useState,
  useReducer,
  useEffect,
  useCallback,
  useRef,
} from "react";
import DataGrid, {
  Column,
  Lookup,
  RequiredRule,
  Item,
  Paging,
  Pager,
  ColumnFixing,
  FormItem,
  Export,
  ColumnChooser,
  Toolbar,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  SearchPanel,
  Editing,
  GroupPanel,
  Grouping,
} from "devextreme-react/data-grid";

import ShowMoreText from "react-show-more-text";
import { Toast } from "devextreme-react/toast";
import * as action from "../../../actions/rps";
import rpsReducer from "../../../reducers/rps";
import { GRID_CONFIG, ViewFiles,postLogForGridOperations } from "./utils";
import { set, get, getTypeOfFile, onDownloadFile } from "../../../common/utils";
import ScrollView from "devextreme-react/scroll-view";
import CustomButton from "./CustomButton";
import { Popup } from "devextreme-react/popup";
import { Button } from "devextreme-react/autocomplete";
import FileUploader from "devextreme-react/file-uploader";
import ACTION_TYPES from "../../../actions/actionTypes";
import moment from "moment";
import { useSelector } from "react-redux";
import { postUserLog } from "../../../actions/common";
import Sps from "../../sps/Sps";
import EditRPSForm from "./EditRPSForm";
import ItemButton from "devextreme-react/button";
import DateBox from "devextreme-react/date-box";
import RadioGroup from "devextreme-react/radio-group";
import NEXUS_CONST from "../../../common/constants";
import { isEmpty, isEqual } from "lodash";
import {setGridUserPrefs, setGridWidthPrefs, applyUserPref, saveUserPref } from "../../../common/utils";
const initialRailState = {
  safety: "",
  railActions: "",
  railEscalated: "",
  railNotes: "",
  railStartDate: "",
  railDueDate: "",
  compDate: "",
  railPriority: "",
  railStatus: "",
  railOwner: "",
  topThree: "",
  railPdca: "",
  railPlan: "",
  railDo: "",
  railCheck: "",
  railAct: "",
  railImageName: "",
};

const initialState = {
  rpsGridData: [],
  peopleList: null,
  tiersList: null,
  approvers: [],
  reasonCodes: [],
  userPrefSps: null
};

export default ({
  rpsId,
  siteId,
  tierId,
  data,
  siteUid,
  activeItem,
  template,
  isEditable,
  tab,
  FromDGrpsPopUpMgr,
  widgetId
}) => {
  const isLightMode = useSelector((state) => state.theme.lightMode);
  const [state, dispatch] = useReducer(rpsReducer, initialState);
  const [rpsEditPopUpMgr, setRPSEditPopUpMgr] = useState(false);
    const { rpsGridData, peopleList, approvers, reasonCodes, tiersList, userPrefSps } = state;
    const GRID_COLS = JSON.stringify(["processOwner", "tierlevel", "tiername", "areaToSolve", "reasonForAction", "startDate", "dueDate", "completedDate", "problemToSolve", "initialState", "initialStateWhiteboard", "initialStateAttachments", "approver", "teamMembers", "tsDoWhat", "tsToWhat", "tsHowMuch", "tsByWhen", "kpiunits", "leasonLearnt", "isContainment", "isExperiments", "resultFrequency", "resultTimePeriod", "whatHelped", "whatHindered", "whatNotWentWell", "whatWentWell", "rootCauseAnalysis", "rootCauseAnalysisWhiteboard", "rootCauseAnalysisAttachments", "andon", "status"]);
    const loggedinUser = get("hid");
    const PREF_KEY = 'userPref_' + widgetId
    const stat = ["Not Started", "In Progress", "Completed"];
  const priority = ["High", "Medium", "Low"];
  const [sqdicp, setSqdicp] = useState(
    template.map((d) => {
      return d.title;
    })
  );
  const rpsDataGrid = useRef(null);
  const [isPopupVisible, setIsPopupVisibility] = useState(false);
  const [isFilePopupVisible, setIsFilePopupVisibility] = useState(false);
  const [railViewInfo, setPopupData] = useState({ initialRailState });
  const [selectedFiles, setSlectedFiles] = useState(null);
  const [onFirstLoad, setOnFirstLoad] = useState(true);
  const [showExportForm, setShowExportForm] = useState(false);
  const [sDate, setSDate] = useState(new Date());
  const [eDate, setEDate] = useState(new Date());
  const [exportFilter, setExportFilter] = useState(0);
  const [popUpImages, setPopUpImages] = useState([]);
  const setDeleted = (d) => {
    delList = d;
  };
  const [showRPS, setShowRPS] = useState(false);
  const [rpsPopUpMgr, setRPSPopUpMgr] = useState(false);
  const [rpsIdRail, setRpsIdRail] = useState(null);
  const [rpsIdAction, setRpsIdAction] = useState(1);
  const [listRPSID, setListRPSID] = useState([]);
  const basePath = window.location.origin;
  const [loading, setLoading] = useState(false);
  const [scrollConfig] = useState({
    showScrollbar: "always",
    scrollByContent: true,
    scrollByThumb: true,
  });
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "info",
    message: "",
  });
  const [isFileRcaPopupVisible, setIsFileRcaPopupVisible] = useState(false);
  let delList = [];
  let rpsConfig = { ...GRID_CONFIG.RPS_GRID_CONFIG };

  const handleClick = () => {
    setLoading(true);
    // Perform your asynchronous operation here, e.g., API request
    // Once the operation is complete, set loading to false
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };

  useEffect(() => {
    let siteInfo = siteUid ? `&siteId=${siteUid}` : "";

    action.fetchUsers(dispatch, `tierId=${tierId}` + siteInfo);
    action.getApproverHighestTier(dispatch, siteId);
    action.fetchReasonCodeByFrequency(dispatch, tierId);

    if (siteUid) action.fetchTiersList(dispatch, siteUid);
    action.fetchRPSGridData(dispatch, tierId + siteInfo);
    //if (siteUid) {
    //    if (rpsConfig.editing.form.items[0].items.indexOf("tierlevel") == -1)
    //        rpsConfig.editing.form.items[0].items.push("tierlevel")
    //}
    //else {
    //    if (rpsConfig.editing.form.items[0].items.indexOf("tierlevel") != -1)
    //        rpsConfig.editing.form.items[0].items.pop("tierlevel")
    //}

    if (!isEditable) {
      rpsConfig.editing.allowUpdating = false;
      rpsConfig.editing.allowAdding = false;
      rpsConfig.editing.allowDeleting = false;
    } else {
      rpsConfig.editing.allowUpdating = true;
      rpsConfig.editing.allowAdding = true;
      rpsConfig.editing.allowDeleting = true;
    }
  }, []);

  useEffect(() => {
    if (onFirstLoad && rpsGridData?.length) {
      let data = rpsGridData?.filter((val) => {
        return val.status !== "Completed";
      });
      dispatch({ type: ACTION_TYPES.FETCH_PERF_GRID, payload: data });
      set("railData", data);
      setOnFirstLoad(false);
    } else {
      set("railData", rpsGridData);
    }
  }, [rpsGridData, onFirstLoad]);

    useEffect(() => {
        action.fetchUserPref(
            dispatch,
            `=${tierId}&SiteUID=${siteId}&widgetID=${widgetId}`
        );
        return () => {
            action.updateUserPref(dispatch, saveUserPref({ widgetId, siteId, tierId, moduleName: 'DownTimeReason', loggedinUser, prefSess: PREF_KEY, GRID_COLS }));
        };
    }, []);

    useEffect(() => {
        if (userPrefSps) set(PREF_KEY, userPrefSps);
        if (rpsDataGrid && rpsDataGrid.current && rpsDataGrid.current.instance !== null && userPrefSps && rpsGridData) {
            applyUserPref(rpsDataGrid, userPrefSps)
        }
    }, [userPrefSps, rpsGridData, peopleList, tiersList])

  const onEditingStart = () => setDeleted([]);
  function onHiding() {
    setToastConfig({
      ...toastConfig,
      isVisible: false,
    });
  }
  //const cellRender = (data) => {
  //    let top3tpl = (data.data && data.data.top3 < 9 && data.data && data.data.top3 > 0) ? <span className="fa-layers fa-fw">
  //        <i className="fas fa-star fa-2x top3-icon"></i>
  //        <span className="fa-layers-text fa-inverse top3-txt primary-txt-clr" data-fa-transform="shrink-8 down-3" >{data.data.top3} </span>
  //    </span > : '';
  //    return <span>{top3tpl} <span className="w-50">{data.value}</span></span>
  //}

  const onContentReady = (e) => {
    //rpsDataGrid.current.instance.updateDimensions();
      
    var columnChooserView = e.component.getView("columnChooserView");
    if (!columnChooserView._popupContainer) {
      columnChooserView._initializePopupContainer();
      columnChooserView.render();
      columnChooserView._popupContainer.option("position", {
        of: e.element,
        my: "right top",
        at: "right top",
        offset: "0 50",
      });
      }
      setGridUserPrefs(e, widgetId)
  };
  const useMethod = () => {
    //rpsDataGrid.current.instance.updateDimensions();
  };

  const lengthyTextCellRender = (data) => {
    let cellText = "";
    if (data.text && data.text.length > 100) {
      cellText = (
        <ShowMoreText
          lines={2}
          more="Show More"
          less="Show Less"
          className="content-css"
          anchorClass="my-anchor-css-class"
          expanded={false}
          width={280}
          onClick={useMethod}
          truncatedEndingComponent={"... "}
        >
          {data.text}
        </ShowMoreText>
      );
      return (data.text = cellText);
    } else {
      cellText = data.text;
      return (data.text = cellText);
    }
  };

  const onRowRemoved = (data) => {
    if (siteUid) {
      let getTiersList = get("tiersList");
      let tierInfo = getTiersList.find((d) => {
        if (d.tierlevel === data.data.tierLevel) return d;
      });
      if (tierInfo) tierId = tierInfo.tierID;
    }
    action.deleteRPSData(dispatch, data.data.id, tierId);
    setToastConfig({
      ...toastConfig,
      isVisible: true,
      type: "success",
      message: "RPS Item Removed Successfully!!",
    });
    //rpsDataGrid.current.instance.updateDimensions();
  };

  const handlers = {
    //  onRowUpdated: onRowUpdated,
    onRowRemoved: onRowRemoved,
    onEditingStart: onEditingStart,
  };

  const togglePopup = () => {
    setIsPopupVisibility(!isPopupVisible);
    //rpsDataGrid.current.instance.updateDimensions();
  };

  const toggleFilePopup = () => {
    setIsFilePopupVisibility(!isFilePopupVisible);
    //rpsDataGrid.current.instance.updateDimensions();
  };

  const toggleFileRcaPopup = () => {
    setIsFileRcaPopupVisible(!isFileRcaPopupVisible);
    //rpsDataGrid.current.instance.updateDimensions();
  };

  function populatePopupData(railData) {
    togglePopup();
    setPopupData({ railViewInfo: railData.row.data });
    //rpsDataGrid.current.instance.updateDimensions();
  }
  function populatePopupRPSData(rpsdata, action1) {
    setRpsIdAction(action1);
    setRpsIdRail(rpsdata.row.data.id);
    setRPSEditPopUpMgr(true);
    //action.fetchRPSGridData();
  }
  const toggleRPSPopup = () => {
    setRPSEditPopUpMgr(!isPopupVisible);
    //rpsDataGrid.current.instance.updateDimensions();
  };

  useEffect(() => {
    set("tiersList", state.tiersList);
  }, [state.tiersList]);
  const handlePropertyChange = (e) => {
    if (
      e.name === "columns" &&
      !isEmpty(e.value) &&
      ["filterType", "filterValue", "filterValues"].includes(
        e.fullName.split(".")[1]
      )
    ) {
      const visibleColumns = rpsDataGrid.current.instance.getVisibleColumns();

      const regex = /\[(\d+)\]/;
      const colIndex = parseInt(e?.fullName.match(regex)[1]);

      const colName = visibleColumns[colIndex]?.dataField
        ? visibleColumns[colIndex]?.dataField
        : visibleColumns.filter((col) =>
            isEqual(
              col.filterValues ? col.filterValues : col.filterValue,
              e.value
            )
          )[0]?.dataField;
      if (!isEmpty(colName)) {
        postUserLog({
          event: "SPS Grid Filter",
          data: {
            action: `Filters/Search applied to ${colName}`,
            module: "Digital Tier",
            section: `${data[activeItem].title}`,
            siteUId: siteId,
            widget: "Structured Problem Solving",
            tierId: tierId,
          },
        });
      }
    }
    postLogForGridOperations(
      rpsDataGrid,
      e,
      siteId,
      tierId,
      "SPS Grid",
      null,
      data[activeItem].title
    );
    //if (e.name === "changedProperty") {
    //rpsDataGrid.current.instance.updateDimensions();
    if (e.value == "Completed") {
      let siteInfo = siteUid ? `&siteId=${siteUid}` : "";
      action.fetchRPSGridData(dispatch, (tierId || "") + siteInfo);
    } else if (e.value == null && e.previousValue == "Completed") {
      setOnFirstLoad(true);
    }
    // }
  };

  const renderContent = () => {
    return (
      <ScrollView
        contentContainerStyle={{ flexGrow: 1, height: "550px" }}
        id="scrollview"
        {...scrollConfig}
      >
        <div class="row">
          <div class="col4">
            <div>
              <label className="view-grid-info"> SQDICP :</label>
              <span> {railViewInfo.railViewInfo.sqdcp}</span>
            </div>
            <br />
            <br />
            <div>
              <label className="view-grid-info"> Escalated :</label>
              <span>
                {" "}
                {railViewInfo.railViewInfo.escTierId == "0"
                  ? "False"
                  : "True"}{" "}
              </span>
            </div>
            <br />
            <br />
          </div>

          <div class="col4">
            <div>
              <label className="view-grid-info"> Start Date :</label>
              <span>
                {" "}
                {new Date(
                  railViewInfo.railViewInfo.startDate
                ).toLocaleDateString()}{" "}
              </span>
            </div>
            <br />
            <br />
            <div>
              <label className="view-grid-info"> Due Date :</label>
              <span>
                {" "}
                {new Date(
                  railViewInfo.railViewInfo.dueDate
                ).toLocaleDateString()}{" "}
              </span>
            </div>
            <br />
            <br />
          </div>
          <div class="col4">
            <div>
              <label className="view-grid-info"> Status :</label>
              <span> {railViewInfo.railViewInfo.status} </span>
            </div>
            <br />
            <br />
            <div>
              <label className="view-grid-info"> Owner :</label>
              <span> {railViewInfo.railViewInfo.ownerName} </span>
            </div>
            <br />
            <br />
          </div>

          <div class="col4">
            <div>
              <label className="view-grid-info"> Actions :</label>
              <span> {railViewInfo.railViewInfo.actions} </span>
            </div>
            <br />
            <br />
            <div>
              <label className="view-grid-info"> Notes :</label>
              <span> {railViewInfo.railViewInfo.notes} </span>
            </div>
            <br />
            <br />
          </div>
          <div class="col4">
            <div>
              <label className="view-grid-info"> Completed Date :</label>
              <span>
                {" "}
                {new Date(
                  railViewInfo.railViewInfo.completedDate
                ).toLocaleDateString()}{" "}
              </span>
            </div>
            <br />
            <br />
            <div>
              <label className="view-grid-info">Priority :</label>
              <span> {railViewInfo.railViewInfo.priority} </span>
            </div>
            <br />
            <br />
          </div>
          <div class="col4">
            <div>
              <label className="view-grid-info"> Top 3 :</label>
              <span> {railViewInfo.railViewInfo.top3} </span>
            </div>
            <br />
            <br />
            <div>
              <label className="view-grid-info"> PDCA :</label>
              <span> {railViewInfo.railViewInfo.pdca} </span>
            </div>
            <br />
            <br />
          </div>
          <div class="col4">
            <div>
              <label className="view-grid-info"> Plan :</label>
              <span> {railViewInfo.railViewInfo.plan} </span>
            </div>
            <br />
            <br />
            <div>
              <label className="view-grid-info"> Do :</label>
              <span> {railViewInfo.railViewInfo.do} </span>
            </div>
            <br />
            <br />
          </div>
          <div class="col4">
            <div>
              <label className="view-grid-info"> Check :</label>
              <span> {railViewInfo.railViewInfo.check} </span>
            </div>
            <br />
            <br />
            <div>
              <label className="view-grid-info"> Act :</label>
              <span> {railViewInfo.railViewInfo.act} </span>
            </div>
            <br />
          </div>
        </div>
      </ScrollView>
    );
  };

  const onFileDel = (d) => {
    let deletedItems = [...delList];
    deletedItems.push(d);
    setDeleted(deletedItems);
  };
  const renderFileContent = () => {
    return (
      <>
        {popUpImages.initialStateAttachments
          ? popUpImages.initialStateAttachments &&
            popUpImages.initialStateAttachments.map((moreInfo, i) => {
              return (
                <div className="d-flex justify-content-between">
                  <div
                    className="file-name pointer"
                    style={{ wordBreak: "break-all" }}
                    onClick={() => {
                      getTypeOfFile(
                        {
                          imageName: moreInfo,
                          folderName: "RPS",
                          subfolderName: "Breakdown",
                          fileExtension: "xls",
                        },
                        "RPS"
                      );
                    }}
                  >
                    {moreInfo}
                  </div>{" "}
                  &nbsp;
                  <>
                    <i
                      title="Download"
                      className="fa fa-download pointer"
                      onClick={() =>
                        onDownloadFile(moreInfo, "RPS", "Breakdown")
                      }
                    ></i>
                  </>
                </div>
              );
            })
          : ""}
      </>
    );
  };
  const renderFileRcaContent = () => {
    return (
      <>
        {popUpImages.rootCauseAnalysisAttachments
          ? popUpImages.rootCauseAnalysisAttachments &&
            popUpImages.rootCauseAnalysisAttachments.map((moreInfo, i) => {
              return (
                <div className="d-flex justify-content-between">
                  <div
                    className="file-name pointer"
                    style={{ wordBreak: "break-all" }}
                    onClick={() => {
                      getTypeOfFile(
                        {
                          imageName: moreInfo,
                          folderName: "RPS",
                          subfolderName: "RootCauseAnalysis",
                          fileExtension: "xls",
                        },
                        "RPS"
                      );
                    }}
                  >
                    {moreInfo}
                  </div>{" "}
                  &nbsp;
                  <>
                    <i
                      title="Download"
                      className="fa fa-download pointer"
                      onClick={() =>
                        onDownloadFile(moreInfo, "RPS", "RootCauseAnalysis")
                      }
                    ></i>
                  </>
                </div>
              );
            })
          : ""}
      </>
    );
  };

  const isRailReady = () => {
    if (siteUid && state.peopleList && state.tiersList) return true;
    else if (state.peopleList) return true;
    return false;
  };
  const cellEditFileUploader = (cellInfo) => (
    <FileUploader
      selectButtonText="Select file"
      uploadMode="useForm"
      multiple={true}
      accept="*"
      labelText="Max. File Size 4 MB"
      maxFileSize={4000000}
      onValueChanged={(e) => {
        cellInfo.data.setValue(e.value);
      }}
    />
  );

  const ViewAttachment = (cellInfo) => (
    <ViewFiles
      files={cellInfo.data.value}
      folderName="RPS"
      moreInfo={cellInfo}
      onRowUpdated={onFileDel}
      updateData={(e) => {
        cellInfo.data.setValue(e);
      }}
    />
  );

  const filePathCellRenderInitialStateAttachments = (data) => {
    return data.value ? (
      <a
        onClick={() => {
          if (data.row.data.initialStateAttachments) {
            setPopUpImages(data.row.data);
            setIsFilePopupVisibility(true);
          }
        }}
      >
        View Attachment
      </a>
    ) : (
      ""
    );
  };

  const filePathCellRenderRootCauseAnalysisAttachments = (data) => {
    return data.value ? (
      <a
        onClick={() => {
          if (data.row.data.rootCauseAnalysisAttachments) {
            setPopUpImages(data.row.data);
            setIsFileRcaPopupVisible(true);
          }
        }}
      >
        View Attachment
      </a>
    ) : (
      ""
    );
  };

  const exportData = (e) => {
    setShowExportForm(!showExportForm);
    getFilteredAndSortedData();
    e.cancel = true;
  };
  const onExportingRPS = (e) => {
    setLoading(true);
    action.exportData("digitaltier/exportRPSData", "Honeywell RPS", {
      lstID:
        (listRPSID.listRPSID && listRPSID.listRPSID.length) > 0
          ? listRPSID.listRPSID
          : null,
      siteId: siteId,
      tierId: tierId,
      widgetId: "",
      isAll: exportFilter == 2 ? false : true,
      startDate: moment(sDate).format("DD/MM/YYYY"),
      endDate: moment(eDate).format("DD/MM/YYYY"),
      section:`${data[activeItem].title}`,
    });

    //.then((res) => {  res.setLoading(false);})
    e.cancel = true;

    // Perform your asynchronous operation here, e.g., API request
    // Once the operation is complete, set loading to false
    if ((tierId = "602"))
      setTimeout(() => {
        setLoading(false);
      }, 9000);
    else
      setTimeout(() => {
        setLoading(false);
      }, 5000);
  };

  const renderAndOn = (cell) => {
    return (
      <div style={{ textAlign: "center", width: "20px", height: "20px" }}>
        {" "}
        <span
          style={{ background: cell.value, textAlign: "center" }}
          className="rpsAndonDot"
        ></span>
      </div>
    );
  };

  const onValueChanged = () => {
    postUserLog({
      event: "SPS Grid Launch",
      data: {
        action: `SPS Widget launch`,
        module: "Digital Tier",
        section: `${data[activeItem].title}`,
        siteUId: siteId,
        widget: "Structured Problem Solving",
        tierId: tierId,
      },
    });
    setRPSPopUpMgr(true);
  };

  useEffect(() => {
    if (rpsPopUpMgr == false) {
      let siteInfo = siteUid ? `&siteId=${siteUid}` : "";
      if (siteUid) action.fetchTiersList(dispatch, siteUid);
      action.fetchRPSGridData(dispatch, tierId + siteInfo);
    }
  }, [rpsPopUpMgr, rpsEditPopUpMgr, FromDGrpsPopUpMgr]);

  const getFilteredAndSortedData = useCallback(() => {
    const grid = rpsDataGrid.current.instance;
    const filterExpr = grid.getCombinedFilter(true);
    const dataSource = grid.getDataSource();
    const loadOptions = dataSource.loadOptions();
    dataSource
      .store()
      .load({
        filter: filterExpr,
        sort: loadOptions.sort,
        group: loadOptions.group,
      })
      .then((result) => {
        if (filterExpr != undefined) {
          if (filterExpr.length >= 3)
            setListRPSID({
              listRPSID: result.map((x) => {
                return x.id;
              }),
            });
        } else {
          setListRPSID({ listRPSID: null });
        }
      });
  }, [rpsDataGrid]);
  const filterValue = [
    ["status", "=", "Open"],
    "and",
    ["areaToSolve", "=", `${data[activeItem].title}`],
  ];

  const calculateFilterExpression = (
    value,
    selectedFilterOperations,
    target
  ) => {
    const column = this;

    if (target === "headerFilter") {
      return [[getOrderDay, "<", value], "or", [getOrderDay, ">", value]];
    }
    /**return defaultCalculateFilterExpression(
      value,
      selectedFilterOperations,
      target
    );**/
  };

  const orderHeaderFilter = (data) => {
    data.dataSource.postProcess = (results) => {
      return results;
    };
  };
  function getOrderDay(rowData) {
    return new Date(rowData.startDate);
  }

  return (
    <>
      <div className="gem-fltr-adj " style={{ right: "297px" }}>
        <div className="dx-field-value-static">
          {isEditable ? (
            <button
              style={{ padding: "11px 14px", cursor: "pointer" }}
              className="dx-button-mode-contained"
              id="link4"
              onClick={onValueChanged}
            >
              <i className="fas fa-plus"></i>
            </button>
          ) : null}
        </div>
      </div>

      {isRailReady() && (
        <DataGrid
          ref={rpsDataGrid}
          dataSource={rpsGridData}
          onExporting={exportData}
          showBorders={true}
          allowColumnReordering={true}
          onContentReady={onContentReady}
          wordWrapEnabled={true}
          onOptionChanged={handlePropertyChange}
          allowColumnResizing={true}
          columnAutoWidth={true}
          // defaultFilterValue={filterValue}
          remoteOperations={true}
          //  onEditorPreparing={onEditorPreparing}
          width="100%"
          height="100%"
          // {...rpsConfig}
          {...handlers}
          onColumnsChanging={e => setGridWidthPrefs(e, widgetId)}
        >
          <Paging defaultPageSize={10} />
          <Pager
            visible={true}
            allowedPageSizes={[5, 10, 20, 50]}
            showPageSizeSelector={true}
            showInfo={true}
            showNavigationButtons={true}
          />

          <ColumnFixing enabled={true} />
          <Export enabled={true} />
          <ColumnChooser enabled={true} mode="select" allowSearch={true} />
          <SearchPanel
            visible={true}
            onTextChange={(e) => {
              if (!isEmpty(e))
                postUserLog({
                  event: "Search SPS Grid",
                  data: {
                    action: `${e} searched in SPS Grid`,
                    module: "Digital Tier",
                    section: `${data[activeItem].title}`,
                    siteUId: siteId,
                    widget: "Structured Problem Solving",
                    tierId: tierId,
                  },
                });
            }}
          />
          <Editing
            mode="row"
            allowUpdating={isEditable}
            allowDeleting={isEditable}
            allowAdding={isEditable}
          />
          <Toolbar>
            <Item visible={true} name="refreshButton" />
            <Item location="before">
              <RadioGroup
                items={[
                  { id: 0, text: "All" },
                  { id: 2, text: "Date range" },
                ]}
                value={exportFilter}
                valueExpr="id"
                displayExpr="text"
                onValueChanged={(e) => setExportFilter(e.value)}
                layout="horizontal"
                visible={showExportForm ? true : false}
              />
            </Item>

            <Item location="before">
              <DateBox
                label="Start Date*"
                labelMode="floating"
                visible={exportFilter == 2 && showExportForm ? true : false}
                value={sDate}
                onValueChanged={(e) => setSDate(e.value)}
                useMaskBehavior={true}
                height={30}
                type="date"
              />
            </Item>
            <Item location="before">
              <DateBox
                label="End Date*"
                labelMode="floating"
                visible={exportFilter == 2 && showExportForm ? true : false}
                value={eDate}
                onValueChanged={(e) => setEDate(e.value)}
                height={30}
                type="date"
                useMaskBehavior={true}
              />
            </Item>
            <Item location="before">
              {/* <ItemButton
                                  text="Export"
                                  visible={showExportForm ? true : false}
                                  height={30}
                                  onClick={onExportingRPS}
                              /> */}

              {showExportForm ? (
                <div className="cbtn d-flex justify-space-between align-items-center">
                  <CustomButton
                    onClick={(e) => onExportingRPS(e)}
                    className="btn secondary-btn"
                    loading={showExportForm ? loading : false}
                  >
                    {loading ? "Loading..." : "Export"}
                  </CustomButton>
                </div>
              ) : (
                <></>
              )}
            </Item>

            <Item location="before">
              {/* <ItemButton
                                  text="Cancel"
                                  visible={showExportForm ? true : false}
                                  onClick={exportData}
                                  height={40}
                                  showBorders={true}
                              /> */}
              {showExportForm ? (
                <div className="cbtn d-flex justify-space-between align-items-center">
                  <button onClick={exportData} className="btn primary-btn">
                    Cancel
                  </button>
                </div>
              ) : (
                <></>
              )}
            </Item>
            <Item location="after" name="exportButton" />
            <Item name="columnChooserButton" />
            <Item name="searchPanel" visible={true} />
          </Toolbar>
          <FilterRow visible={true} />
          {/* <FilterPanel visible={true} /> */}
          <GroupPanel visible={true} />
          <HeaderFilter visible={true} />
          <Grouping autoExpandAll={false} />
          {
            //// <RemoteOperations
            //  filtering={true}
            //   paging={true}
            //     sorting={true}
            //      summary={true}
            //       grouping={true}
            //groupPaging={true}
            //   />
          }
          <Column
            dataField="id"
            caption="ID"
            dataType="number"
            allowEditing={false}
            width={90}
            visible={true}
            showInColumnChooser={false}
          ></Column>
          <Column
            dataField="processOwner"
            caption="Process Owner"
            dataType="string"
            width={150}
            visible={true}
            allowHeaderFiltering={true}
            allowFiltering={false}
          >
            <Lookup
              items={peopleList}
              valueExpr="employeeId"
              displayExpr="employeeName"
            />
          </Column>
          <Column
            dataField="tierlevel"
            caption="Tier Level"
            dataType="number"
            allowEditing={false}
          ></Column>
          <Column
            dataField="tiername"
            caption="Tier Name"
            dataType="string"
            allowEditing={false}
          ></Column>
          <Column
            dataField="areaToSolve"
            caption="Area To Solve"
            dataType="string"
            visible={true}
            width={350}
            // filterValue={data[activeItem].title}
            // filterValues={data[activeItem].title}
            allowHeaderFiltering={true}
            allowFiltering={false}
          >
            <Lookup dataSource={sqdicp} />
          </Column>

          <Column
            dataField="reasonForAction"
            caption="Reason For Actions"
            dataType="string"
            visible={true}
            width={450}
            cellRender={lengthyTextCellRender}
          >
            <RequiredRule />
          </Column>
          <Column
            dataField="startDate"
            caption="Start Date"
            dataType="date"
            visible={true}
            width={150}
            editorOptions={{
              useMaskBehavior: false,
              displayFormat: "MM/dd/yyyy",
            }}
            allowFiltering={false}
            allowHeaderFiltering={true}
            format="MM/dd/yyyy"
            dateSerializationFormat="MM/dd/yyyy"
            // calculateFilterExpression={(e) => { calculateFilterExpression }}
          >
            {
              //   <HeaderFilter dataSource={orderHeaderFilter} />
            }
            <RequiredRule />
          </Column>
          <Column
            dataField="dueDate"
            caption="Due Date"
            dataType="date"
            visible={true}
            width={150}
            editorOptions={{
              useMaskBehavior: false,
              displayFormat: "MM/dd/yyyy",
            }}
            allowHeaderFiltering={true}
            allowFiltering={false}
            format="MM/dd/yyyy"
            dateSerializationFormat="MM/dd/yyyy"
          >
            <RequiredRule />
          </Column>
          <Column
            dataField="completedDate"
            caption="Completed Date"
            dataType="date"
            width={110}
            editorOptions={{ useMaskBehavior: true }}
          ></Column>
          <Column
            dataField="problemToSolve"
            caption="Problem To Solve"
            dataType="string"
            allowEditing={false}
          >
          </Column>
          <Column
            dataField="initialState"
            caption="Initial State"
            dataType="string"
            width={100}
            encodeHtml={false}
          ></Column>
          <Column
            dataField="initialStateWhiteboard"
            caption="Initial State WhiteBaord"
            dataType="string"
            visible={false}
            width={100}
          ></Column>

          <Column
            dataField="initialStateAttachments"
            dataType="string"
            {...{
              caption: "Initial State Attachments",
              allowEditing: true,
              //   editorOption: { allowEditing: true },
              visible: true,
            }}
            editCellComponent={ViewAttachment}
            cellRender={filePathCellRenderInitialStateAttachments}
          >
            <FormItem colSpan={2} />
          </Column>

          <Column
            dataField="approver"
            caption="Approver"
            dataType="string"
            visible={true}
            width={150}
          >
            <Lookup items={approvers} valueExpr="id" displayExpr="name" />
          </Column>
          <Column
            dataField="teamMembers"
            caption="Team Members"
            dataType="string"
            visible={true}
            width={150}
          >
            {/* <Lookup items={peopleList} valueExpr="employeeId"
                displayExpr="employeeName" /> */}
          </Column>
          {
            //<Column dataField="lsImageName" dataType="string" {...{
            //caption: "Attachments",
            //allowEditing: true,
            //editorOption: { allowEditing: true },
            // visible: true,
            //}}
            //editCellComponent={ViewAttachment}
            //cellRender={filePathcellRender}
            //>
            //<FormItem colSpan={2} />
            //</Column>
          }
          {
            //         <Column
            //           {...{
            //             dataField: "imageName",
            //           caption: "Upload Attachments",
            //         allowEditing: true,
            //       editorOption: { allowEditing: true },
            //     visible: false,
            //  }}
            //editCellComponent={cellEditFileUploader}
            //cellRender={filePathcellRender}
            //>
            //  <FormItem colSpan={2} />
            //</Column>
          }
          <Column
            dataField="tsDoWhat"
            caption="Do What"
            dataType="string"
            visible={true}
            width={70}
          ></Column>

          <Column
            dataField="tsToWhat"
            caption="To What"
            dataType="string"
            cellRender={lengthyTextCellRender}
            visible={true}
            width={200}
          ></Column>

          <Column
            dataField="tsHowMuch"
            caption="How Much"
            dataType="string"
            visible={true}
            width={200}
            cellRender={lengthyTextCellRender}
          ></Column>
          <Column
            dataField="tsByWhen"
            caption="By When"
            visible={true}
            dataType="string"
            width={200}
          ></Column>
          <Column
            dataField="kpiunits"
            caption="KPI Units"
            dataType="string"
            visible={true}
            width={70}
          ></Column>

          <Column
            dataField="leasonLearnt"
            caption="Leason Learnt"
            dataType="string"
            visible={true}
            width={70}
          ></Column>

          <Column
            dataField="isContainment"
            caption="Is Containment"
            dataType="string"
            visible={true}
            width={70}
          ></Column>

          <Column
            dataField="isExperiments"
            caption="Is Experiments"
            dataType="string"
            visible={true}
            width={70}
          ></Column>

          <Column
            dataField="resultFrequency"
            caption="Result Frequency"
            dataType="string"
            visible={true}
            width={70}
          ></Column>
          <Column
            dataField="resultTimePeriod"
            caption="Result TimePeriod"
            dataType="string"
            visible={true}
            width={70}
          ></Column>

          <Column
            dataField="whatHelped"
            caption="what WentWell"
            dataType="string"
            visible={true}
            width={70}
          ></Column>

          <Column
            dataField="whatHindered"
            caption="what Hindered"
            dataType="string"
            visible={true}
            width={70}
          ></Column>

          <Column
            dataField="whatNotWentWell"
            caption="what NotWentWell"
            dataType="string"
            visible={true}
            width={70}
          ></Column>

          <Column
            dataField="whatWentWell"
            caption="what WentWell"
            dataType="string"
            visible={true}
            width={70}
          ></Column>
          <Column
            dataField="rootCauseAnalysis"
            caption="Root Cause Analysis"
            dataType="string"
            visible={true}
            width={200}
            encodeHtml={false}
          ></Column>
          <Column
            dataField="rootCauseAnalysisWhiteboard"
            caption="Root Cause Analysis WhiteBoard"
            visible={false}
            width={200}
          ></Column>

          <Column
            dataField="rootCauseAnalysisAttachments"
            dataType="string"
            {...{
              caption: "Root Cause Analysis Attachments",
              allowEditing: true,
              editorOption: { allowEditing: true },
              visible: true,
            }}
            editCellComponent={ViewAttachment}
            cellRender={filePathCellRenderRootCauseAnalysisAttachments}
          >
            <FormItem colSpan={2} />
          </Column>
          <Column
            dataField="andon"
            caption="Andon"
            width={80}
            cellRender={renderAndOn}
            allowFiltering={true}
          />
          <Column
            dataField="status"
            caption="Status"
            visible={true}
            allowFiltering={false}
            allowHeaderFiltering={true}
            //filterValues={["Open","Close"]}
          >
            <Lookup
              dataSource={NEXUS_CONST.statusList}
              valueExpr="value"
              displayExpr="value"
            />
          </Column>
          <Column
            dataField="metric"
            caption="Module"
            visible={true}
            allowFiltering={false}
            allowHeaderFiltering={true}
            //filterValues={["Open","Close"]}
          >
           
          </Column><Column
            dataField="subModule"
            caption="Sub Module"
            visible={true}
            allowFiltering={false}
            allowHeaderFiltering={true}
            //filterValues={["Open","Close"]}
          >
          </Column>
          <Column
            fixed={true}
            type="buttons"
            id="popup"
            minWidth={100}
            height="100%"
            showInColumnChooser={false}
          >
            <Button
              name="view"
              hint="View Details"
              icon="info"
              onClick={(e) => {
                populatePopupRPSData(e, "info");
              }}
            ></Button>
            <Button
              name="edit"
              onClick={(e) => {
                populatePopupRPSData(e, "edit");
              }}
              icon="edit"
            ></Button>
            <Button name="delete" icon="trash"></Button>
          </Column>
        </DataGrid>
      )}
      {isPopupVisible && (
        <Popup
          // mode="popup"
          width={500}
          height={500}
          showTitle={true}
          title={"View RPS Details"}
          dragEnabled={false}
          hideOnOutsideClick={true}
          onHiding={togglePopup}
          visible={isPopupVisible}
          onOptionChanged={() => {
            rpsDataGrid.current.instance.refresh();
          }}
          contentRender={renderContent}
        ></Popup>
      )}
      {isFilePopupVisible && (
        <Popup
          // mode="popup"
          width={600}
          height={500}
          showTitle={true}
          title={"Attachments"}
          dragEnabled={false}
          hideOnOutsideClick={true}
          onHiding={toggleFilePopup}
          visible={isFilePopupVisible}
          contentRender={renderFileContent}
        ></Popup>
      )}
      {isFileRcaPopupVisible && (
        <Popup
          // mode="popup"
          width={600}
          height={500}
          showTitle={true}
          title={"Attachments"}
          dragEnabled={false}
          hideOnOutsideClick={true}
          onHiding={toggleFileRcaPopup}
          visible={isFileRcaPopupVisible}
          contentRender={renderFileRcaContent}
        ></Popup>
      )}
      {rpsEditPopUpMgr && (
        <Sps
          rpsID={rpsIdRail}
          tierId={tierId}
          siteId={siteId}
          activeItem={activeItem}
          data={template}
          closeShift={(d) => setRPSEditPopUpMgr(d)}
          isRail={false}
        />
      )}
      <Toast
        visible={toastConfig.isVisible}
        message={toastConfig.message}
        type={toastConfig.type}
        onHiding={onHiding}
        displayTime={2000}
      />
      {rpsPopUpMgr && (
        <Sps
          rpsId={rpsIdRail}
          tierId={tierId}
          siteId={siteId}
          activeItem={activeItem}
          data={template}
          closeShift={(d) => setRPSPopUpMgr(d)}
          isRail={false}
        />
      )}
    </>
  );
};
